module.exports = __webpack_public_path__ + "static/media/incomplete_bar.93664b26.svg";